import React from 'react';
import { motion } from 'framer-motion';
import { Clock } from 'lucide-react';

export const SessionLimitBanner = ({ countdown, onLearnMore }) => (
  <motion.div
    initial={{ opacity: 0, y: -8 }}
    animate={{ opacity: 1, y: 0 }}
    exit={{ opacity: 0, y: -8 }}
    transition={{ duration: 0.3, ease: [0.4, 0, 0.2, 1] }}
    className="mt-3 rounded-2xl overflow-hidden shadow-sm"
    data-testid="session-limit-banner"
  >
    <div className="h-0.5 bg-gradient-to-r from-amber-400 via-orange-400 to-amber-500" />
    <div className="bg-gradient-to-br from-amber-50 via-orange-50 to-amber-50 border border-amber-200/60 border-t-0 rounded-b-2xl px-4 py-3.5">
      <div className="flex items-start gap-3">
        <div className="w-9 h-9 rounded-xl bg-amber-100 border border-amber-200/60 flex items-center justify-center flex-shrink-0 mt-0.5">
          <Clock className="w-4 h-4 text-amber-600" />
        </div>
        <div className="flex-1 min-w-0">
          <p className="text-sm font-semibold text-amber-900 leading-snug">
            All try-ons used for this session
          </p>
          <p className="text-xs text-amber-700 mt-1 leading-relaxed">
            Browse freely and explore{' '}
            <span className="font-semibold text-purple-700">Moments ✨</span> or{' '}
            <span className="font-semibold text-blue-700">Size Guide</span> on any look you've already tried.
          </p>
          <div className="mt-2.5 flex items-center gap-2 flex-wrap">
            {countdown && (
              <div className="flex items-center gap-1 bg-white/70 border border-amber-200/50 px-2.5 py-1 rounded-full">
                <Clock className="w-3 h-3 text-amber-500" />
                <span className="text-[11px] text-amber-700 leading-none">
                  Session ends in{' '}
                  <span className="font-bold font-mono text-amber-900 tracking-tight">{countdown}</span>
                </span>
              </div>
            )}
            <button
              onClick={onLearnMore}
              className="text-[11px] text-amber-600 underline underline-offset-2 hover:text-amber-800 transition-colors leading-none"
              data-testid="session-limit-learn-more"
            >
              What can I do?
            </button>
          </div>
        </div>
      </div>
    </div>
  </motion.div>
);
